export default [
    {
        youtubeId: 'pYHKPCUdHfE',
        title: '"Bukan Mainan atau jalan jalan, begini cara membahagiakan anak"',
        by: 'Caroline Widjanarko'
    },
    {
        youtubeId: 'gxuLbemAo9Q',
        title: '"Anak Pemarah dan Kasar, inikah sebabnya?"',
        by: 'Henny Wirawan'
    },
    {
        youtubeId: 'RJGc43IZVZg',
        title: '"Anak makannya lama, jangan disuapi"',
        by: 'Charlotte Priatna'
    },
    {
        youtubeId: '_xBC5ly9jI8',
        title: '"Tips agar anak tangguh dan Mandiri"',
        by: 'Charlotte Priatna'
    },
    {
        youtubeId: 'YXhHhlk4p8s',
        title: '"5 Bahasa yang dapat membuat anak merasa dikasihi"',
        by: 'Adi W Gunawan'
    },
    
]